export default "__VITE_ASSET__DRu008NC__";